import MenuBar from "./Component/MenuBar";
import PageBanner from './Component/PageBanner';
import Sidebar from './Component/Sidebar';
import Footer from "./Component/Footer";
import BlogsCard from "./Component/BlogsCard";
import BlogsData from "./Component/BlogsData";
const BlogDetails = () => {
    return (
        <>
            <MenuBar />
            <Sidebar />
            <PageBanner title="Blog Details" current="BLOG Details" crumbs={[{ to: "/USA/Blogs", label: "Blogs" }]} />


            {/* <!--Sidebar Page Container--> */}
            <div className="sidebar-page-container">
                <div className="auto-container">
                    <div className="event-detail-image">
                        <figure className="image">
                            <img src="https://radhamadhavsociety.org/images/blog/2019/Canmore-Retreat-1.jpg" alt="" />

                        </figure>

                    </div>

                    <div className="row clearfix">

                        {/* <!--Content Side / Blog Detail--> */}
                        <div className="content-side col-lg-12 col-md-12 col-sm-12">
                            <div className="post-details">
                                {/* <!--Event Details--> */}
                                <div className="event-details">
                                    <div className="lower-box">
                                        <h2>Canmore Retreat</h2>

                                        <div className="post-content">

                                            <p>
                                                Devotees from various parts of Canada and US gathered for a retreat near Banff, Canada. Guided by Sushri Siddheshvari Devi Ji, this third annual retreat was held at Copperstone Resort at the base of Rocky Mountains. The natural beauty of the surroundings perfectly complimented the beauty of the retreat’s devotional atmosphere, and the tall and majestic mountains silently inspired all to reach the heights of devotion
                                            </p>





                                        </div>

                                        <div className="info-box clearfix">
                                            <div className="cause-info">
                                                <ul className="clearfix">
                                                    <li><span className="far fa-clock"></span> August 31 - Starts 5.00 PM - Ends 9:00 PM</li>
                                                    {/* <!--<li><span className="fa fa-map-marker-alt"></span> Tottenham, London N17 6HW</li>--> */}
                                                </ul>
                                            </div>
                                            {/* <!--<div className="clearfix">
                                            
                                            <div className="share-post clearfix">
                                                <div className="share-title">Share This</div>
                                                <ul className="social-links clearfix">
                                                    <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                                                    <li><a href="#"><span className="fab fa-facebook-f"></span></a></li>
                                                    <li><a href="#"><span className="fab fa-instagram"></span></a></li>
                                                    <li><a href="#"><span className="fab fa-youtube"></span></a></li>
                                                </ul>
                                            </div>
                                        </div>--> */}

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                        {/* <!--End Content Side--> */}

                    </div>
                </div>
            </div>
            {/* <!-- End Sidebar Page Container --> */}













            <Footer />



        </>


    )

}


export default BlogDetails;
